import React from 'react';
import Link from '@material-ui/core/Link';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import EmailForm from './EmailForm';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '1440px',
    },
  },
  contactWrap: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '30px',
      marginLeft: '30px',
    },
  },
  title: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      fontSize: 32,
    },
  },
  socialMediaWrapper: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
      marginTop: '20px',
      width: '550px',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '10px',
    },
  },
  socialMediaIconWrapper: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: '20px',
      marginTop: '16px',
      marginBottom: '16px',
    },
  },
  backpack: {
    width: '280px',
    height: '290px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '-65px',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  hwEmail: {
    color: theme.palette.secondary.light,
  },
  mlhCode: {
    color: theme.palette.secondary.light,
    marginTop: '10px',
    display: 'flex',
  },
}));

const SocialMediaIconWrapper = styled.div`
  & > a {
    margin-right: 20px;
  }
`;

const SocialMediaIcons = styled.img`
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

const Footer = ({ actions }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.contactWrap} id="contact">
        <Typography variant="h1" className={classes.title}>
          Don't be a stranger!
        </Typography>
        <div className={classes.socialMediaWrapper}>
          <SocialMediaIconWrapper className={classes.socialMediaIconWrapper}>
            <Link href="https://www.instagram.com/hackwestern/" target="_Blank">
              <SocialMediaIcons
                src={require('./assets/_instagram.png')}
                alt="hwInstagram"
              />
            </Link>
            <Link href="https://www.facebook.com/hackwestern" target="_Blank">
              <SocialMediaIcons
                src={require('./assets/facebook.png')}
                alt="hwFacebook"
              />
            </Link>
            <Link
              href="https://www.linkedin.com/company/hack-western/about/"
              target="_Blank">
              <SocialMediaIcons
                src={require('./assets/linkedin.png')}
                alt="hwLinkedIn"
              />
            </Link>
            <Link href="https://twitter.com/hackwestern" target="_Blank">
              <SocialMediaIcons
                src={require('./assets/twitter.png')}
                alt="hwTwitter"
              />
            </Link>
          </SocialMediaIconWrapper>
          <Link href="mailto:hello@hackwestern.com" className={classes.hwEmail}>
            <b>hello@hackwestern.com</b>
          </Link>
        </div>
        {/* <EmailForm
          actions={actions}
          customStyles={{
            width: '100%',
          }}
        /> */}

        <Link
          href="https://static.mlh.io/docs/mlh-code-of-conduct.pdf"
          target="_Blank"
          className={classes.mlhCode}>
          MLH Code of Conduct
        </Link>
      </div>
      <img
        src={require('./assets/backpack.png')}
        alt="backpack"
        className={classes.backpack}
      />
    </div>
  );
};

export default Footer;
